import React from "react";
import AuthFooterTabs from "./AuthFooterTabs";

export default function RegisterBottomTabs({ p }) {
  return (
    <AuthFooterTabs
      setOpenSupport={p.setOpenSupport}
      setOpenCalculator={p.setOpenCalculator}
    />
  );
}
